import React from 'react'
import './style.scss'
import bem from '../../helpers/bem'

const Hint = ({
                title,
                info,
                close,
                type,
                hints,
                list,
              }) => {
  const block = 'hint';

  const getVisibleMods = () => {
    return {
      'visible': !!hints.find(hint => hint.type === type).visible,
    };
  };

  const getTypeMods = () => {
    return {
      [type]: !!type,
    }
  };

  const handleClickClose = () => {
    return close(type);
  };

  return (
    <div className={bem({
      block, elem: 'wrapper', mods: {
        ...getVisibleMods(),
        ...getTypeMods(),
      }
    })}>
      <div
        className={bem({block, elem: 'dark', mods: getTypeMods()})}
        onClick={handleClickClose}
      />
      <div className={bem({block, mods: getTypeMods()})}>
        <div className={bem({block, elem: 'title', mods: getTypeMods()})}>
          {title}
        </div>
        <ul className={bem({block, elem: 'list'})}>
          {list && list.map((item, index) => {
            return <li key={item + index}>
              {item}
            </li>
          })}
        </ul>
        <div className={bem({block, elem: 'info', mods: getTypeMods()})}>
          {info}
        </div>
        <div
          className={bem({block, elem: 'close'})}
          onClick={handleClickClose}
        >
        </div>
      </div>
    </div>
  )
};

export default Hint;